<template>
  <v-container fluid>
    <v-row justify="space-around">
      <v-col cols="12">
        <v-row v-if="!user.access_token">
          <v-col>
            <p>
              {{ $t('home.askco') }}
            </p>
            <v-btn color="primary" @click="logIn()">
              {{ $t('nav.login') }}
            </v-btn>
          </v-col>
        </v-row>
        <v-row v-else-if="changes.length > 0">
          <v-col align="center" v-for="(changesItem, i) in changes" :key="i" cols="12" class="pa-0">
            <v-item-group>
              <v-item v-slot="{ toggle }">
                <div @click="toggle" style="width: 100%">
                  <changes-cards-item :changesItem="changesItem"> </changes-cards-item>
                </div>
              </v-item>
            </v-item-group>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col>
            <p>
              {{ $t('changes.welcome') }}
            </p>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import ChangesCardsItem from './ChangesCardsItem.vue';

export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters(['changes', 'user', 'rules_fav', 'subs_fav']),
  },
  components: {
    ChangesCardsItem,
  },
  beforeMount() {
    if (this.user.access_token) {
      this.getChanges();
    } else {
      this.$authService.renewToken().then((user) => {
        if (['true', 'TRUE', 'True'].indexOf(user.profile.isCotisant) < 0 && user.profile.source != 'AzureAD') {
          this.$router.push('/logout');
        }
      });
    }
  },
  methods: {
    ...mapMutations(['setChanges']),
    async logIn() {
      try {
        //authentification
        await this.$authService.signIn();
      } catch (err) {
        console.error(err);
      }
    },
    async getChanges() {
      const url = '/changes';
      const request = { method: 'GET', url: url };
      // console.log("ON TENTE DE CHOPER LES CHANGES");
      try {
        const response = await this.axios(request);
        // console.log("ON A LA REPONSE", response);
        let allChanges = response.data;
        let changes = allChanges.map((change) => {
          let changeItem = {
            nb_rules: 0,
            nb_sub: 0,
            data: { all: change.data, rulesconcern: [], subsconcern: {} },
            date: change.date,
            empty: true,
          };
          // filter of fav
          for (const [ruleID, subIDsObj] of Object.entries(change.data)) {
            for (const subID in subIDsObj) {
              if (this.subs_fav.indexOf(subID) >= 0) {
                if (!changeItem.data.subsconcern[subID]) {
                  changeItem.data.subsconcern[subID] = [];
                  changeItem.nb_sub = changeItem.nb_sub + 1;
                  changeItem.empty = false;
                }
                if (this.rules_fav.indexOf(ruleID) >= 0) {
                  changeItem.data.subsconcern[subID].push(ruleID);
                }
              }
            }
            if (this.rules_fav.indexOf(ruleID) >= 0) {
              changeItem.nb_rules = changeItem.nb_rules + 1;
              changeItem.empty = false;
              changeItem.data.rulesconcern.push(ruleID);
            }
          }
          return changeItem;
        });
        this.setChanges(changes);
      } catch (err) {
        console.log(err);
      }
    },
  },
  watch: {
    // Permet de suivre l'etat de USER et relancer
    user() {
      this.getChanges();
    },
  },
};
</script>
